export default __webpack_public_path__ + "static/media/rivers.a2d20a95.png";